export interface Column1ViewModelState {
  genericDocCashbookListingState: any;
  }
  
  export const initialState: Column1ViewModelState = {
  genericDocCashbookListingState: null,
  };